module.exports = __webpack_public_path__ + "static/media/2_en.9509c145.png";